<router-outlet></router-outlet>
<mat-progress-bar *ngIf="loadingRouteConfig" style="position: absolute; top: 0;" mode="query"></mat-progress-bar>